import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { numberStep, stringStep } from '../../../concepts/commands/CommandWizard';
import { AlertHub } from './AlertHub';

const computeDelay = (message: string, inputDelay: any) =>
    inputDelay === 0 ? 0 : (
        parseInt(inputDelay) || Math.max(20000, Math.min(5000, `${message}`.length * 60))
    );

export const alert = defineCommand(
    'alert',
    'Alert...',
    (r, [message, delay, type, modal]: [string, (number | string)?, string?, boolean?]) => {
        const alerts = r.call(AlertHub);
        type = type || 'default';
        message = `${message}`;
        alerts.invoke({ type, body: message, delay: computeDelay(message, delay), modal: !!modal });
    },
    [
        stringStep('message', 'Enter the message:'),
        numberStep('timeout', 'Enter the timeout (optional):', 0),
    ]
);

export const sendAlert = defineCommand(
    'sendAlert',
    'Alert: Send...',
    (r, [message, delay, type, modal]: [string, number?, string?, any?]) => {
        const alerts = r.call(AlertHub);
        type = type || 'default';
        message = `${message}`;
        alerts.sendAndInvoke({ type, body: message, delay: computeDelay(message, delay), modal: !!modal });
    },
    [
        stringStep('message', 'Enter your message:'),
        numberStep('timeout', 'Enter the timeout (optional):', 0),
    ]
);
